import {
  Box,
  CardContent,
  CardHeader,
  Divider,
  Typography,
} from "@mui/material";
import { IconCash } from "@tabler/icons-react";
import MoedaText from "../../../util/ui/inputs/moedaText";
import { Skeleton } from "@mui/material";
import { Moment } from "moment";
import { ResultadoImposto } from "../../../../models/imposto";
import FelixCard from "../../../util/ui/felixCard";

type Props = {
  mes: Moment;
  resultado?: ResultadoImposto;
};

export default function CardResultado({ resultado }: Props) {
  // Valor negativo em `destructive`, positivo em `positive` — nunca verde/vermelho puro.
  const getColor = (numero: number) => {
    if (numero < 0) return "error.main";
    if (numero === 0) return "text.primary";
    if (numero > 0) return "success.main";
  };

  return (
    <FelixCard>
      <CardHeader title="Resultado" avatar={<IconCash size={16} />} />
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="center">
          <Typography
            color={getColor(resultado?.resultadoTotal ?? 0)}
            sx={{
              fontVariantNumeric: "tabular-nums",
              fontWeight: 600,
              fontSize: 28,
              letterSpacing: "-0.02em",
              paddingBottom: 2,
            }}
          >
            {resultado ? (
              <MoedaText value={resultado.resultadoTotal} />
            ) : (
              <Skeleton variant="text" width={40} animation={false} />
            )}
          </Typography>
        </Box>
        <Box display="flex" alignItems="flex-end">
          <Box
            display="flex"
            flexShrink={1}
            width="100%"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="dataMono"
              color={getColor(resultado?.operacoesComuns.resultadoTotal ?? 0)}
              sx={{ fontWeight: 500 }}
            >
              {resultado ? (
                <MoedaText value={resultado.operacoesComuns.resultadoTotal} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
            <Typography variant="labelMono" color="text.secondary" mt={0.5}>
              Comuns
            </Typography>
          </Box>
          <Divider
            sx={{ m: 1 }}
            orientation="vertical"
            variant="middle"
            flexItem
          />
          <Box
            display="flex"
            flexShrink={1}
            width="100%"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="dataMono"
              color={getColor(resultado?.operacoesDaytrade.resultadoTotal ?? 0)}
              sx={{ fontWeight: 500 }}
            >
              {resultado ? (
                <MoedaText value={resultado.operacoesDaytrade.resultadoTotal} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
            <Typography variant="labelMono" color="text.secondary" mt={0.5}>
              Daytrade
            </Typography>
          </Box>
          <Divider
            sx={{ m: 1 }}
            orientation="vertical"
            variant="middle"
            flexItem
          />
          <Box
            display="flex"
            flexShrink={1}
            width="100%"
            flexDirection="column"
            alignItems="center"
          >
            <Typography
              variant="dataMono"
              color={getColor(resultado?.operacoesFii.resultadoTotal ?? 0)}
              sx={{ fontWeight: 500 }}
            >
              {resultado ? (
                <MoedaText value={resultado.operacoesFii.resultadoTotal} />
              ) : (
                <Skeleton variant="text" width={40} animation={false} />
              )}
            </Typography>
            <Typography variant="labelMono" color="text.secondary" mt={0.5}>
              FII/Fiagro
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </FelixCard>
  );
}
